import { QueryClient } from '@tanstack/react-query'
import { AxiosInstance } from 'axios'
import { SnapshotIn } from 'mobx-state-tree'

import { NamedServerConfig } from '#config'
import { createScriptoApiClient } from '#util'
import { DatadogClient } from '#util/datadog'
import { LocalPersistence } from '#util/LocalPersistence'
import { MixpanelClient } from '#util/mixpanel'

import { Root } from './models/Root'
import type { Environment } from './types'

export * from './types'

export { MstProvider, useMst } from './MstContext'

export const createRootStore = (opts: {
  config: NamedServerConfig
  axios: AxiosInstance
  localPersistence: LocalPersistence
  snapshot: SnapshotIn<typeof Root>
  queryClient: QueryClient
}) => {
  const { config, axios, localPersistence, snapshot, queryClient } = opts
  const analytics = new MixpanelClient(config.MIXPANEL_TOKEN || '')
  const env: Environment = {
    config,
    apiClient: createScriptoApiClient(axios),
    localPersistence,
    analytics,
    datadog: DatadogClient.getInstance(),
    queryClient,
  }

  const store = Root.create(snapshot, env)
  store.environment.datadog.initializeContextTracking(store)
  return store
}
